/*
 * Copyright (c) Arbeidskracht Groep B.V. - all rights reserved
 */

export enum DisplayType {
	DISPLAY_TYPE_NONE = 'DISPLAY_TYPE_NONE',
	DISPLAY_TYPE_REMEMBER_ME = 'DISPLAY_TYPE_REMEMBER_ME',
	DISPLAY_TYPE_CREDENTIALS = 'DISPLAY_TYPE_CREDENTIALS',
	DISPLAY_TYPE_RETRY_PHONE_VERIFICATION_START = 'DISPLAY_TYPE_RETRY_PHONE_VERIFICATION_START',
	DISPLAY_TYPE_VERIFICATION_CODE = 'DISPLAY_TYPE_VERIFICATION_CODE',
	DISPLAY_TYPE_ENTER_PASSWORD = 'DISPLAY_TYPE_ENTER_PASSWORD'
}
